export default class Kindergarten {

    constructor() {
        this.id = null;
        this.name = null;
        this.kindergartenType = null;
        this.mapsEnabled = null;
        this.province = null;
        this.federalState = null;
        this.sections = null;
        this.street = null;
        this.zip = null;
        this.city = null;
        this.executive = null;
        this.unreadRegistrations = 0;
        this.executives = [];
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let kindergarten = new Kindergarten();
        kindergarten.id = data.id;
        kindergarten.name = data.name;
        if (data.kindergartenType) {
            kindergarten.kindergartenType = data.kindergartenType;
        }
        kindergarten.mapsEnabled = data.mapsEnabled;
        kindergarten.province = data.province;
        if (data.federalState) {
            kindergarten.federalState = data.federalState
        }
        kindergarten.sections = data.sections;
        if (data.street) {
            kindergarten.street = data.street;
        }
        if (data.zip) {
            kindergarten.zip = data.zip;
        }
        if (data.city) {
            kindergarten.city = data.city;
        }
        if (data.executive) {
            kindergarten.executive = data.executive;
        }
        if (data.unreadRegistrations) {
            kindergarten.unreadRegistrations = data.unreadRegistrations;
        }
        if (data.executives) {
            kindergarten.executives = data.executives;
        }

        Object.seal(kindergarten);
        return kindergarten;
    }

    concatAddress() {
        let parts = [];
        if (this.street !== null) {
            parts.push(this.street);
        }
        if (this.zip !== null && this.city !== null) {
            parts.push(this.zip + ' ' + this.city);
        } else if (this.zip !== null) {
            parts.push(this.zip);
        } else if (this.city !== null) {
            parts.push(this.city);
        }
        return parts.join(', ');
    }
}
